import * as React from "react";
import {useTranslation} from "react-i18next";
import {getShopId} from "../../../lib/getShopId";

const OurStandards: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div className="list-our-standards">
      <div className="h3">{t("checkout.ourStandards")}</div>

      <div className="checkmarks standards">
        <ul>
          <li>
            <a href={t("url.privacyLinkAndAnchor")}>{t("general.privacy")}</a>
          </li>
          <li>{t("checkout.sslEncryption")}</li>
          <li>{t("checkout.ourReturnPolicy")}</li>
          <li>{t("checkout.prepaymentDiscount")}</li>
          <li>{t("checkout.fastDelivery")}</li>
        </ul>
      </div>

      {getShopId() !== 100022 && getShopId() !== 100029 && getShopId() !== 100005 && (
        <div className="logos">
          {getShopId() === 100001 && (
            <a
              className="image-link"
              href="https://ehi-siegel.de/verbraucher/shops-mit-siegel/zertifizierte-shops/zertifikat/49bb580bf7970bf8d4303874bec9bc7c/"
              title="Zertifizierung aufrufen"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon icon-trust-ehi">&#160;</span>
            </a>
          )}

          {getShopId() === 100009 && (
            <a
              className="image-link"
              href="https://www.guetezeichen.at/zertifikate/shopzertifikat/wwwconnoxat/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="sprite sprite-austria-ecg">&#160;</span>
            </a>
          )}

          {getShopId() === 100017 ||
            (getShopId() === 100027 && (
              <a
                className="image-link"
                href="https://www.vsv-versandhandel.ch/members/detail/connox-gmbh/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sprite sprite-austria-ecg">&#160;</span>
              </a>
            ))}

          {getShopId() === 100020 && (
            <a
              className="image-link"
              title="SafeBuy Recommended Action: click me to see Retailer Accreditation Certificate for this website (new tab/window)"
              href="https://www.safebuy.org.uk/certificate/93313bbb-8efe-4ca5-83ec-3231711f8ccf.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon icon-trust-safebuy">&#160;</span>
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default OurStandards;
